import { useContext } from 'react';

import { DataContext } from './data-context';

export const useData = () => {
  const { data } = useContext(DataContext);
  return data;
};

export const useAddGoalToCreate = () => {
  const { addGoalToCreate } = useContext(DataContext);
  return addGoalToCreate;
};

export const useAddTagToCreate = () => {
  const { addTagToCreate } = useContext(DataContext);
  return addTagToCreate;
};
